import React from "react";
import "./Tamwood.css";
import canadaHeader from "../assets/Cannada1.png";
import tamwooedInfo from "../assets/fsheet-0001 1.png";
import { Helmet } from "react-helmet";

function Tamwood() {
  return (
    <div>
      <Helmet>
         <title>Tamwood Program | Londonhouse </title>
      </Helmet>
    <div className="cannada-info-container">
      <div className="cannda-head">
        <div className="head-background">
          <img src={canadaHeader} alt="cover-picture" />
        </div>
      </div>
      <div className="all-info">
        <img src={tamwooedInfo} alt="all information" />
      </div>
    </div>
    </div>
  );
}

export default Tamwood;
